import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { DialogModule } from '@progress/kendo-angular-dialog';

import { KpaInsideSpinnerComponent } from '../kpa-inside-spinner/kpa-inside-spinner.component';
import { KpaSpinnerComponent } from './kpa-spinner.component';

@NgModule({
	declarations: [KpaSpinnerComponent, KpaInsideSpinnerComponent],
	imports: [CommonModule, DialogModule, FlexLayoutModule],
	exports: [KpaSpinnerComponent, KpaInsideSpinnerComponent],
})
export class KpaSpinnerModule {}
